import {createContext, useContext} from 'react';

import type {AfriexAdminTransaction} from '@/types';

export type TransactionContextType = {
  totalPendingTransactions: number | null;
  fetchPendingTransactions: (
    limit?: number,
    page?: number,
  ) => Promise<AfriexAdminTransaction[] | undefined>;
  totalFailedTransactions: number | null;
  fetchFailedTransactions: (
    limit?: number,
    page?: number,
  ) => Promise<AfriexAdminTransaction[] | undefined>;
  // Menu path -> label suffix, e.g. '/transactions/pending' -> '(12)'.
  menuSuffixes: Record<string, string>;
};

// The context object and its hook live in this JSX-free module so that
// TransactionProvider.tsx only exports a component and keeps its Fast Refresh
// boundary. Consumers keep importing `useTransactionContext` from
// '@/context/TransactionContext'.
export const TransactionContext = createContext<TransactionContextType>(
  {} as TransactionContextType,
);

export function useTransactionContext() {
  return useContext(TransactionContext);
}
